exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.documentBlocInfo[data-v-9245c4c4] {\n  border: 1px solid grey;\n  overflow: auto;\n}\n.documentBlocInfo + .documentBlocInfo[data-v-9245c4c4] {\n  border-left: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9245c4c4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/detailPages/supplierDetailPages/SupplierDocForm.vue
// module id = 1635
// module chunks = 2